import api from "@/utils/axios";

const ORDERS_API_URL = `/orders`;

export default {
  namespaced: true,
  state: {
    orders: [],
    order: null,
    loading: false,
    error: null,
  },
  mutations: {
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
    SET_ORDER(state, order) {
      state.order = order;
    },
    UPDATE_ORDER(state, updatedOrder) {
      const index = state.orders.findIndex((o) => o.id === updatedOrder.id);
      if (index !== -1) {
        state.orders.splice(index, 1, updatedOrder);
      }
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ORDER(state) {
      state.order = null;
      state.orders = [];
      state.error = null;
    },
  },
  actions: {
    async fetchOrders(
      { commit },
      {
        filters = {},
        search = "",
        sort_by = "-created_at",
        page = 1,
        limit = 20,
      }
    ) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.post(`${ORDERS_API_URL}/filter/`, {
          filters,
          search,
          sort_by,
          page,
          limit,
        });
        commit("SET_ORDERS", response.data.orders);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchOrder({ commit }, orderId) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.get(`${ORDERS_API_URL}/${orderId}/`);
        commit("SET_ORDER", response.data.order);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async advanceOrderStatus({ commit }, { orderId }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.post(
          `${ORDERS_API_URL}/${orderId}/advance/`
        );
        commit("SET_ORDER", response.data.order);
        commit("UPDATE_ORDER", response.data.order);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async cancelOrderStatus({ commit }, { orderId }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.post(`${ORDERS_API_URL}/${orderId}/cancel/`);
        commit("SET_ORDER", response.data.order);
        commit("UPDATE_ORDER", response.data.order);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || error.message);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    orders: (state) => state.orders,
    order: (state) => state.order,
    orderLoading: (state) => state.loading,
    orderError: (state) => state.error,
  },
};
